import * as T from 'io-ts';
const OptionalGameStateT = T.partial({ leader: T.string });
const RequiredGameStateT = T.type({
    current_card: T.number,
    phase: T.keyof({ lobby: null, vote: null, review: null }),
    show: T.boolean,
    shuffle: T.record(T.string, T.number),
});
export const StateT = T.intersection([OptionalGameStateT, RequiredGameStateT]);
export const PartialStateT = T.intersection([OptionalGameStateT, T.partial(RequiredGameStateT.props)]);
